import findByIdOrThrow from "../findByIdOrThrow"
import type { HasHP } from "../has_hp"
import entityTypeMetaList from "./entityTypeMetaList.generated"
import type { Entity } from "./index"

export default function isEntityAtFullHp(entity: Entity) {
  const { hp: defaultHp } = findByIdOrThrow(entityTypeMetaList, entity.etype_id).entDefaults as HasHP
  return (entity as HasHP).hp >= defaultHp
}